import { isApiErrorResult, ToError, ToFieldKeyOnly } from '@scoring/api';

export const trySetFormApiErrors = (
    error: unknown,
    form: { setFieldError: (field: string, error: string) => void }
) => {
    if (isApiErrorResult(error)) {
        const err = ToError(error);
        err.validationErrors
            .filter((ve) => !ve.isGeneral)
            .forEach((ve) => {
                form.setFieldError(ToFieldKeyOnly(ve.field), ve.errors.join(', '));
            });
    }
};
